import React from 'react';
import styles from './MissionVision.module.scss';
import Reveal from 'react-awesome-reveal';
import { flipFromLeft } from '../Animation/Animation';
import { Typography } from '../Typography';

const MissionVision = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.cardsWrapper}>
          <div className={styles.missionCard}>
            <Reveal keyframes={flipFromLeft} duration={1000} delay={100} triggerOnce>
              <div className={styles.cardContent}>
                <Typography variant="display-xl" as="h2" color="grayDark-50" weight="semibold" className={styles.title}>
                  Our Mission
                </Typography>
                <Typography variant="text-lg" color="grayDark-50" className={styles.description}>
                  Our mission is to create robust, developer-friendly technologies that streamline the development of video plugins, graphics tools, and performance-critical software. We aim to reduce technical friction and enable teams to focus on creativity, innovation, and product quality.
                </Typography>
              </div>
            </Reveal>
          </div>
          <div className={styles.visionCard}>
            <Reveal keyframes={flipFromLeft} duration={1000} delay={200} triggerOnce>
              <div className={styles.cardContent}>
                <Typography variant="display-xl" as="h2" color="grayDark-50" weight="semibold" className={styles.title}>
                  Our Vision
                </Typography>
                <Typography variant="text-lg" color="grayDark-50" className={styles.description}>
                  We envision EPEN as a global reference point for advanced video and software development solutions. By combining deep engineering expertise with a strong understanding of real-world production needs, we strive to shape the future of video technology across platforms and industries.
                </Typography>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionVision;

